<template>
    <div v-if="bannerActive" class="banner" :class="bannerClasses" :style="bannerStyles">
        <div class="rich-text" v-html="renderRichText(blok.text)"></div>
        <div v-if="blok.closeable" class="close-btn" tabindex="0" @keydown.enter="closeBanner" @click="closeBanner">
            <NuxtIcon name="ri:close-line" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ICoreBanner } from '~ui/types/components/Banner';
import { EHideOnType } from '~ui/types/enums/ComponentStyle';
import { buildBackground } from '~ui/utils/styleBuilder';

const { blok } = defineProps<{ blok: ICoreBanner }>();
const bannerActive = ref(true);
const bannerStyles = computed(() => ({
    'text-align': blok.textAlignment,
    'padding-top': blok.paddingTop ? `${blok.paddingTop}px` : null,
    'padding-bottom': blok.paddingBottom ? `${blok.paddingBottom}px` : null,
    'padding-left': blok.paddingLeft ? `${blok.paddingLeft}px` : null,
    'padding-right': blok.paddingRight ? `${blok.paddingRight}px` : null,
    ...buildBackground(blok.background?.[0]),
}));

const bannerClasses = computed(() => ({
    'hidden-desktop': blok.hideOn === EHideOnType.Desktop,
    'hidden-mobile': blok.hideOn === EHideOnType.Mobile,
}));

const closeBanner = () => {
    bannerActive.value = false;
};
</script>

<style scoped lang="postcss">
.banner {
    &.hidden-desktop,
    &.hidden-desktop:has(.close-btn) {
        @apply md:hidden;
    }
    &.hidden-mobile,
    &.hidden-mobile:has(.close-btn) {
        @apply max-md:hidden;
    }

    &:has(.close-btn) {
        @apply flex;
        .rich-text {
            @apply flex-1;
        }
    }

    .close-btn {
        @apply h-fit pt-1 cursor-pointer;
    }
}
:deep(.rich-text) {
    @apply flex flex-col justify-center;
    p {
        @apply m-0;
    }
    .font-size-xs {
        @apply text-xs;
    }
    .font-size-sm {
        @apply text-sm;
    }
    h1 {
        @apply max-md:text-3xl;
    }
    h2 {
        @apply max-md:text-2xl;
    }
    h3 {
        @apply max-md:text-xl;
    }
    h4 {
        @apply max-md:text-lg;
    }
    h5 {
        @apply max-md:text-base;
    }
    p {
        @apply max-md:text-sm;
    }
}
</style>
